module.exports = __webpack_public_path__ + "assets/21cae1dd5257f20b06297ea8b9153a53.mp4";